/* =============================================================================
 * Copyright (c) 2026 SKYXOPS Corp. All rights reserved.
 * ============================================================================= */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { Toaster } from '@skyxops/ui';
import './index.css';
import { App } from './App';
import { startWebVitalsReporter } from './webVitalsReporter';
import { applyBootTheme } from './bootTheme';
import { DEFAULT_LOCALE, messagesFor, resolveLocale } from './i18n';

startWebVitalsReporter();

// Pre-paint theme restore. Extracted to ./bootTheme so it can be tested —
// main.tsx itself cannot be imported in a test (it mounts the whole app).
applyBootTheme();

const locale = resolveLocale();
const messages = messagesFor(locale);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <IntlProvider locale={locale} defaultLocale={DEFAULT_LOCALE} messages={messages}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      {/* Sonner toast outlet — descendants can call toast.* anywhere. */}
      <Toaster richColors position="bottom-right" />
    </IntlProvider>
  </React.StrictMode>,
);
